export const EVENT_TYPE = {
  PROSPECT_STAGE_ENTERED: 'prospect.stage.entered',
  PROSPECT_ASSIGNED: 'prospect.assigned',
  PROSPECT_BROADCAST_BATCH: 'prospect.broadcast.batch',
  PROSPECT_REASSIGN_DUE_INACTIVITY: 'prospect.reassign_due_inactivity',
  PROSPECT_DAILY_FOLLOWUP: 'prospect.daily_followup',
} as const;

export type EventType = (typeof EVENT_TYPE)[keyof typeof EVENT_TYPE];

export interface EventTypeOption {
  type: EventType;
  description: string;
}

/**
 * Options exposed to the UI when binding a webhook to one or more events.
 * `prospect.stage.entered` is intentionally omitted — that binding is configured
 * per-stage via `stage_webhook_bindings`, not as a global event binding.
 */
export const EVENT_TYPE_OPTIONS: readonly EventTypeOption[] = [
  { type: EVENT_TYPE.PROSPECT_ASSIGNED, description: 'eventTypes.prospectAssigned' },
  {
    type: EVENT_TYPE.PROSPECT_BROADCAST_BATCH,
    description: 'eventTypes.prospectBroadcastBatch',
  },
  {
    type: EVENT_TYPE.PROSPECT_REASSIGN_DUE_INACTIVITY,
    description: 'eventTypes.prospectReassignDueInactivity',
  },
  {
    type: EVENT_TYPE.PROSPECT_DAILY_FOLLOWUP,
    description: 'eventTypes.prospectDailyFollowup',
  },
] as const;

export const BINDING_SOURCE = {
  STAGE: 'stage',
  EVENT: 'event',
} as const;

export type BindingSource = (typeof BINDING_SOURCE)[keyof typeof BINDING_SOURCE];
